module.exports = __webpack_public_path__ + "images/emoji/lips.c7cb57a8beeb77b8f3a4.png";